export var initialState = {
  route: {}
};
export var DEFAULT_COUNTRY = 'SG';
export var DEFAULT_GROUP_MEMBER = 'INSN';
export var DEFAULT_CLIENT_ID = '123456';
export var DEFAULT_LOCALE = 'en';
export var DEFAULT_GLOBAL_CHANNEL = 'PARTNER';
export var DEFAULT_GBGF = 'RBWM';
export var DEFAULT_CORRELATION = '2d933d80-be43-11e7-92e1-005056a61740';